import FaviconBaseController from "./favicon_base_controller.js";
import { memoizeFIFO } from "../helpers/memoize.js";

export default class extends FaviconBaseController {
  static targets = [
    "mediaImageUploader",
    "nextBtn",
    "cropSection",
    "croppedImage",
    "cropperImageContainer",
    "loader",
    "title",
    "selectedThumb",
    "thumbImg",
  ];

  initialize() {
    super.initialize();
    this.mediaImageUploader = $(this.mediaImageUploaderTarget);
    this.cropperSection = $(this.cropSectionTarget);
    this.cropperImageContainer = this.cropperSection.find(
      ".media__cropper-image-container"
    );
    this.croppedImageSelector = this.cropperSection.find("#cropped-image");
    this.showImageDrawer();
    this.urlToBase64Store = memoizeFIFO(this.fetchImageAsBase64, { size: 3 });
  }

  save() {
    this.applyFavicon(
      this.mediaSelectCropper,
      this.croppedImageSelector,
      this.getImageName()
    );
    this.showProcessingLoader();
  }

  cancel() {
    this.goBack(this.cropSectionTarget, this.mediaImageUploaderTarget);
    this.mediaSelectCropper.reset_zoom_slider();
  }

  async fetchImageAsBase64(url) {
    const data = await fetch(url, { headers: { "Cache-Control": "no-cache" } });
    const blob = await data.blob();
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = () => {
        resolve(reader.result);
      };
      reader.onerror = reject;
    });
  }

  async imageUrlToBase64() {
    const thumbImgElement = this.thumbImgTarget;
    const updatedURL = thumbImgElement.getAttribute('data-large-url');

    const base64data = await this.urlToBase64Store(updatedURL);

    try {
      await this.setupImageForCropping(
        this.cropperImageContainer,
        base64data
      );
      this.mediaSelectCropper = this.initializeFaviconCropper(
        this.cropperSection
      );
      this.hideLoader(this.loaderTarget);
      this.goForward(
        this.mediaImageUploaderTarget,
        this.cropSectionTarget
      );
      return base64data;
    } catch (e) {
      this.hideLoader(this.loaderTarget);
      return;
    }
  }

  getImageName() {
    return this.titleTarget.innerText;
  }
}
